import { collection, doc, getDocs, query, where, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";

// Deleting a dream or fear keeps its tasks: in the caller's batch, clear the link (`link`, an entry of TASK_LINKS) on
// every task that names it. Found on the server, not from the app's list, so a task this device hasn't loaded is
// cleared too. Needs a connection.
export const unlinkTasks = async (batch, uid, link, id) => {
  const snap = await getDocs(query(collection(db, "users", uid, "tasks"), where(link.field, "==", id)));
  snap.docs.forEach(d => batch.update(doc(db, "users", uid, "tasks", d.id), { [link.field]: null, updatedAt: serverTimestamp() }));
};
